// Error codes returned by venuemonk-id auth endpoints. Must stay in sync with
// backend/venuemonk-id/src/common/constants/appConstants.js.

export const ERROR_DEVICE_CHANGE_REQUIRED = 'DEVICE_CHANGE_REQUIRED';
export const ERROR_SESSION_SUPERSEDED = 'SESSION_SUPERSEDED';
export const ERROR_ACCESS_DISABLED_APP = 'ACCESS_DISABLED_APP';
export const ERROR_ACCESS_DISABLED_WEB = 'ACCESS_DISABLED_WEB';

// User-facing messages — exact wording per product spec.
export const MSG_DEVICE_CHANGE_REQUIRED = "Your account is already registered with another device/browser. A device change request has been recorded. Please contact your reporting manager or admin for approval.";
export const MSG_SESSION_SUPERSEDED = "You have been logged out because your account was accessed from another device.";
export const MSG_ACCESS_DISABLED = "Your access to this platform has been disabled. Please contact administrator.";

export function getMessageForErrorCode(code) {
    switch (code) {
        case ERROR_DEVICE_CHANGE_REQUIRED: return MSG_DEVICE_CHANGE_REQUIRED;
        case ERROR_SESSION_SUPERSEDED: return MSG_SESSION_SUPERSEDED;
        case ERROR_ACCESS_DISABLED_APP:
        case ERROR_ACCESS_DISABLED_WEB:
            return MSG_ACCESS_DISABLED;
        default: return null;
    }
}
